import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommEyeIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.44293 7.89534C4.89195 9.10618 3.72645 10.5547 3.06624 11.4805C2.90292 11.7095 2.82519 11.8213 2.77885 11.9103C2.7494 11.9669 2.74948 11.9824 2.74956 11.9976L2.74957 12L2.74956 12.0024C2.74948 12.0176 2.7494 12.0331 2.77885 12.0897C2.82519 12.1787 2.90292 12.2905 3.06624 12.5195C3.72645 13.4453 4.89195 14.8938 6.44293 16.1047C7.99545 17.3167 9.88091 18.25 11.9996 18.25C14.1182 18.25 16.0037 17.3167 17.5562 16.1047C19.1072 14.8938 20.2727 13.4453 20.9329 12.5195C21.0962 12.2905 21.174 12.1787 21.2203 12.0897C21.2497 12.0331 21.2497 12.0176 21.2496 12.0024L21.2496 12L21.2496 11.9976C21.2497 11.9824 21.2497 11.9669 21.2203 11.9103C21.174 11.8213 21.0962 11.7095 20.9329 11.4805C20.2727 10.5547 19.1072 9.10618 17.5562 7.89534C16.0037 6.68331 14.1182 5.75 11.9996 5.75C9.88091 5.75 7.99545 6.68331 6.44293 7.89534ZM5.51988 6.71298C7.22552 5.38141 9.42901 4.25 11.9996 4.25C14.5701 4.25 16.7736 5.38141 18.4793 6.71298C20.1864 8.04576 21.4483 9.61974 22.1542 10.6095C22.1716 10.634 22.1894 10.6588 22.2074 10.6837C22.4605 11.0358 22.7496 11.4378 22.7496 12C22.7496 12.5622 22.4605 12.9642 22.2074 13.3163C22.1894 13.3412 22.1716 13.366 22.1542 13.3905C21.4483 14.3803 20.1864 15.9542 18.4793 17.287C16.7736 18.6186 14.5701 19.75 11.9996 19.75C9.42901 19.75 7.22553 18.6186 5.51988 17.287C3.8127 15.9542 2.55084 14.3803 1.84498 13.3905C1.8275 13.366 1.80972 13.3412 1.79176 13.3163C1.53861 12.9642 1.24957 12.5622 1.24957 12C1.24957 11.4378 1.53861 11.0358 1.79176 10.6837C1.80972 10.6588 1.8275 10.634 1.84498 10.6095C2.55084 9.61974 3.8127 8.04576 5.51988 6.71298Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M12 14.25C10.7574 14.25 9.75002 13.2426 9.75002 12C9.75002 10.7574 10.7574 9.75 12 9.75C13.2427 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2427 14.25 12 14.25ZM8.25002 12C8.25002 14.0711 9.92895 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92895 8.25 8.25002 9.92893 8.25002 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
